export const formatCOP = (value: number) =>
  new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 0,
  }).format(value || 0);

export const formatNumber = (value: number) =>
  Number(value || 0).toLocaleString("es-CO");
